import { render, staticRenderFns } from "./customDialogHead.vue?vue&type=template&id=f2f827da&scoped=true"
import script from "./customDialogHead.vue?vue&type=script&lang=js"
export * from "./customDialogHead.vue?vue&type=script&lang=js"
import style0 from "./customDialogHead.vue?vue&type=style&index=0&id=f2f827da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f827da",
  null
  
)

export default component.exports